<div class="mt-3">
  <label for="question" class="form-label mb-1">{{questionMetaData.questionText}}</label>
  @switch (questionMetaData.questionType) {
    @case ('MultiSelect') {
      <p-multiselect
        name="question"
        id="question"
        optionLabel="answerText"
        optionValue="questionAnswerId"
        placeholder="Select one or more options"
        [options]="questionMetaData.answers"
        #currentQuestion="ngModel"
        required
        styleClass="custom-ng-multiselect"
        [(ngModel)]="multipleAnswersGivenToQuestion"
        (ngModelChange)="onAnswerChanged()"
        [ngClass]="{'is-invalid': currentQuestion && currentQuestion.touched && currentQuestion.invalid}"
        [style]="{ width: '100%' }"
        [appendTo]="'body'"
        [showToggleAll]="false"
        [filter]="false">
      </p-multiselect>
    }
    @case ('SelectList') {
      <select
        name="question"
        id="question"
        [ngClass]="{'is-invalid' : currentQuestion && currentQuestion.touched && currentQuestion.invalid}"
        required
        #currentQuestion="ngModel" class="form-select form-select-solid"
        [(ngModel)]="singleAnswerGivenToQuestion"
        data-control="select2" data-placeholder="Choose one">
        @for (option of questionMetaData.answers; track option.questionAnswerId) {
          <option
            [ngValue]="option.questionAnswerId">
            {{option.answerText}}
          </option>
        }
      </select>
    }
    @default {
      <input
        class="form-control form-control-solid" autocomplete="off"
        #currentQuestion="ngModel"
        [(ngModel)]="singleAnswerGivenToQuestion"
        placeholder=""
        id="question"
        name="question"
        [ngClass]="{'is-invalid' : currentQuestion && currentQuestion.touched && currentQuestion.invalid}"
        required/>
    }
  }
  <div class="invalid-feedback">Please, answer the question.</div>
</div>

@for (answer of question.answers; track answer.questionAnswerId) {
  @for (borrowerId of question.validForBorrowerIds; track borrowerId) {
    @if (multipleAnswersGivenToQuestion.includes(answer.questionAnswerId)) {
      <div class="mt-3">
        @for (subsequentQuestion of answer.questions; track subsequentQuestion.questionId) {
          <ask-question
            [questionMetaData]="questionMetaDataByQuestionId.get(subsequentQuestion.questionId)"
            [question]="subsequentQuestion">
          </ask-question>
        }
      </div>
    }
  }
}
